import { createMuiTheme } from '@material-ui/core/styles';


const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#948882'
        },
      },
});

theme.spacing(10);

export default theme;